<div class="form-group mb-10">
    <div class="col-xs-6">
        <sp-input-num
            prefixImgUrl="./assets/img/websites/lt-border-radius-icon.svg"
            suffixText="px"
            [min]="BORDER_RADIUS_MIN"
            [max]="BORDER_RADIUS_MAX"
            [value]="borderTopLeftRadiusValue"
            (valueChange)="setBorderTopLeftRadius($event)"
        ></sp-input-num>
    </div>
    <div class="col-xs-6">
        <sp-input-num
            prefixImgUrl="./assets/img/websites/rt-border-radius-icon.svg"
            suffixText="px"
            [min]="BORDER_RADIUS_MIN"
            [max]="BORDER_RADIUS_MAX"
            [value]="borderTopRightRadiusValue"
            (valueChange)="setBorderTopRightRadius($event)"
        ></sp-input-num>
    </div>
</div>
<div class="form-group mb-20">
    <div class="col-xs-6">
        <sp-input-num
            prefixImgUrl="./assets/img/websites/lb-border-radius-icon.svg"
            suffixText="px"
            [min]="BORDER_RADIUS_MIN"
            [max]="BORDER_RADIUS_MAX"
            [value]="borderBottomLeftRadiusValue"
            (valueChange)="setBorderBottomLeftRadius($event)"
        ></sp-input-num>
    </div>
    <div class="col-xs-6">
        <sp-input-num
            prefixImgUrl="./assets/img/websites/rb-border-radius-icon.svg"
            suffixText="px"
            [min]="BORDER_RADIUS_MIN"
            [max]="BORDER_RADIUS_MAX"
            [value]="borderBottomRightRadiusValue"
            (valueChange)="setBorderBottomRightRadius($event)"
        ></sp-input-num>
    </div>
</div>